import { getBackendUrl } from '../config/api';

export const parseApiDate = (dateString) => {
  const [day, month, year] = dateString.split('-');
  const monthNames = {
    'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
    'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
  };
  return new Date(parseInt(year), monthNames[month], parseInt(day));
};

export const getCurrentPeriod = (dashaHierarchy, level) => {
  if (!dashaHierarchy) return null;
  const now = new Date();
  if (level === 'mahadasha') {
    return dashaHierarchy.find(period => {
      const startDate = parseApiDate(period.start_date);
      const endDate = parseApiDate(period.end_date);
      return now >= startDate && now <= endDate;
    });
  } else if (level === 'antardasha') {
    const currentMahadasha = dashaHierarchy.find(period => {
      const startDate = parseApiDate(period.start_date);
      const endDate = parseApiDate(period.end_date);
      return now >= startDate && now <= endDate;
    });
    if (currentMahadasha?.children) {
      return currentMahadasha.children.find(ad => {
        const startDate = parseApiDate(ad.start_date);
        const endDate = parseApiDate(ad.end_date);
        return now >= startDate && now <= endDate;
      });
    }
  }
  return null;
};

export const fetchCurrentDashaContext = async (userInfo) => {
  // Returns { mahadasha, antardasha, ad_end } or null
  if (!userInfo?.date || !userInfo?.time || !userInfo?.place) return null;
  try {
    const response = await fetch(`${getBackendUrl()}/api/hierarchical-dasha?years=120`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        date: userInfo.date,
        time: userInfo.time,
        place: userInfo.place,
        gender: userInfo.gender || 'Male',
      }),
    });
    if (!response.ok) return null;
    const data = await response.json();
    const md = getCurrentPeriod(data.dasha_hierarchy, 'mahadasha');
    const ad = getCurrentPeriod(data.dasha_hierarchy, 'antardasha');
    if (!md || !ad) return null;

    // Format ad_end as "Mon YYYY" (e.g. "Mar 2027")
    const adEnd = parseApiDate(ad.end_date);
    const adEndFormatted = adEnd.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });

    return {
      mahadasha: md.planet,
      antardasha: ad.planet,
      ad_end: adEndFormatted,
    };
  } catch {
    return null;
  }
};
